import { render, staticRenderFns } from "./mat_cancel.vue?vue&type=template&id=f6489c88&scoped=true&"
import script from "./mat_cancel.vue?vue&type=script&lang=js&"
export * from "./mat_cancel.vue?vue&type=script&lang=js&"
import style0 from "./mat_cancel.vue?vue&type=style&index=0&id=f6489c88&scoped=true&lang=less&"
import style1 from "./mat_cancel.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6489c88",
  null
  
)

export default component.exports